<template>
  <v-form
    ref="itemsform"
    lazy-validation
  >
    <v-text-field
      v-model="editedItem.region_name"
      label="Region Name"
      outlined
      :rules="[rules.required]"
    />
    <v-text-field
      v-model="editedItem.region_short"
      label="Short Code"
      outlined
      :rules="[rules.required]"
    />
    <v-text-field
      v-model="editedItem.region_ip"
      label="IP Prefix"
      outlined
      :rules="[rules.required]"
    />
    <v-switch
      v-model="editedItem.disable_alerts"
      label="Disable Alerts"
      true-value="y"
      false-value="n"
    />
    <v-select
      v-model="editedItem.dr_region_id"
      :items="regions"
      item-text="region_short"
      item-value="region_id"
      label="DR Region"
    />
  </v-form>
</template>
<script>
  export default {
    name: 'RegionForm',
    props: {
      editedItem: Object,
      regions: Array
    },
    data () {
      return {
        rules: {
          required: value => !!value || 'Required.',
        },
      }
    },

  }
</script>